import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

    static values = {
        place: String,
        startsAt: String,
        endsAt: String,
        coachId: Number,
        procedureId: Number,
        state: String,
        reserveUrl: String,
        cancelUrl: String,
        reservationCode: Number,
        startOfWeek: String
    }

    connect() {
        this.tooltip = null
        this.showTooltipBound = this.showTooltip.bind(this)
        this.hideTooltipBound = this.hideTooltip.bind(this)
        this.element.addEventListener('mouseenter', this.showTooltipBound)
        this.element.addEventListener('mouseleave', this.handleMouseLeave.bind(this))
    }

    showTooltip() {
        if (!this.tooltip) {
            this.tooltip = document.createElement('div')
            this.tooltip.className = 'timetable-tooltip'
            this.tooltip.style.position = 'absolute'

            const state = this.stateValue;
            let buttonText = "Registruotis"
            let buttonStyle= "btn-primary"
            let buttonDisabled = false
            let url = this.reserveUrlValue

            let isCancellation = false

            switch (state) {
                case "registered":
                    buttonText = "Atšaukti"
                    buttonStyle = "btn-negative"
                    url = this.cancelUrlValue
                    isCancellation = true
                    break;
                case "full":
                    buttonText = "Pilna"
                    buttonStyle = "btn-negative"
                    buttonDisabled = true
                    break;
                case "ended":
                    buttonText = "Įvyko"
                    buttonStyle = "btn-primary"
                    buttonDisabled = true
                    break;
                case "participated":
                    buttonText = "Sudalyvauta"
                    buttonStyle = "btn-primary"
                    buttonDisabled = true
                    break;
            }

            const inputs = isCancellation ? `
            <input type="hidden" name="reservation_code" value="${this.reservationCodeValue}" />
            <input type="hidden" name="start_of_week" value="${this.startOfWeekValue}" />
        ` : `
            <input type="hidden" name="starts_at" value="${this.startsAtValue}" />
            <input type="hidden" name="ends_at" value="${this.endsAtValue}" />
            <input type="hidden" name="coach_id" value="${this.coachIdValue}" />
            <input type="hidden" name="procedure_id" value="${this.procedureIdValue}" />
        `;

            this.tooltip.innerHTML = `
            <form
                action="${url}"
                data-controller="form"
                data-action="form#handleSubmit"
                method="post"
                id="workout-actions-form"
            >
                <div class="tooltip-content">
                    <div class="tooltip-title">${this.element.querySelector('.timetable-entry-title').textContent.trim()}</div>
                    <div>${this.placeValue}</div>
                    ${inputs}
                    <button class="btn ${buttonStyle} p-1 fs-rm mt-3" ${buttonDisabled ? 'disabled' : ''} data-loader="workout-actions-form">${buttonText}</button>
                </div>
            </form>
        `
            document.body.appendChild(this.tooltip)
            this.tooltip.addEventListener('mouseenter', () => this.tooltipMouseEnter())
            this.tooltip.addEventListener('mouseleave', () => this.tooltipMouseLeave())
        }

        const rect = this.element.getBoundingClientRect()
        const windowWidth = window.innerWidth
        const scrollX = window.scrollX
        const scrollY = window.scrollY

        this.tooltip.style.display = 'block'
        this.tooltip.style.left = `${rect.right + scrollX + 10}px`
        this.tooltip.style.top = `${rect.top + scrollY - 45}px`

        const tooltipRect = this.tooltip.getBoundingClientRect()
        const wouldOverflow = tooltipRect.right > windowWidth

        if (wouldOverflow) {
            this.tooltip.style.left = `${rect.left + scrollX - tooltipRect.width - 10}px`
        }

        this.tooltip.offsetHeight
        this.tooltip.classList.remove('is-hiding')
        this.tooltip.classList.add('is-visible')
    }

    hideTooltip() {
        if (this.tooltip) {
            this.tooltip.classList.remove('is-visible')
            this.tooltip.classList.add('is-hiding')

            setTimeout(() => {
                if (this.tooltip && !this.tooltip.classList.contains('is-visible')) {
                    this.tooltip.style.display = 'none'
                    this.tooltip.classList.remove('is-hiding')
                }
            }, 200)
        }
    }

    handleMouseLeave(event) {
        const toElement = event.relatedTarget
        if (!this.tooltip?.contains(toElement)) {
            this.hideTooltip()
        }
    }

    tooltipMouseEnter() {
        if (this.tooltip) {
            this.tooltip.classList.remove('is-hiding')
            this.tooltip.classList.add('is-visible')
            this.tooltip.style.display = 'block'
        }
    }

    tooltipMouseLeave() {
        this.hideTooltip()
    }

    disconnect() {
        this.element.removeEventListener('mouseenter', this.showTooltipBound)
        this.element.removeEventListener('mouseleave', this.hideTooltipBound)
        if (this.tooltip) {
            this.tooltip.remove()
            this.tooltip = null
        }
    }
}
